// import React, { useState } from "react";
// import { signInWithEmailAndPassword } from "firebase/auth";
// import { auth } from "../firebase";
// import { useNavigate } from "react-router-dom";

// const Login = () => {
//   const [form, setForm] = useState({ email: "", password: "" });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     try {
//       await signInWithEmailAndPassword(auth, form.email, form.password);
//       setLoading(false);
//       navigate("/dashboard");
//     } catch (err) {
//       setError("Invalid email or password.");
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-fuchsia-300 via-sky-200 to-purple-400 py-8 px-2">
//       <div className="w-full max-w-4xl bg-white/80 shadow-2xl rounded-2xl flex flex-col md:flex-row overflow-hidden border border-blue-100 backdrop-blur">
//         {/* LEFT: Welcome Panel */}
//         <div className="hidden md:flex md:w-1/2 bg-gradient-to-br from-fuchsia-700 via-blue-700 to-indigo-700 flex-col justify-center items-center text-white p-10 relative">
//           <svg
//             className="absolute left-4 top-6 w-14 h-14 opacity-70"
//             fill="none"
//             viewBox="0 0 100 100"
//           >
//             <circle cx="50" cy="50" r="50" fill="#fff" fillOpacity="0.1" />
//           </svg>
//           <img
//             src="/logo.png"
//             alt="Logo"
//             className="w-24 h-24 mb-6 drop-shadow-lg"
//           />
//           <h1 className="text-3xl font-extrabold mb-2 drop-shadow-md">
//             Welcome Back!
//           </h1>
//           <div className="mb-4 text-lg font-medium text-fuchsia-100">
//             Login to your account to continue.
//           </div>
//           <div className="text-xs opacity-50">
//             Your education-commerce platform
//           </div>
//         </div>

//         {/* RIGHT: Login Form */}
//         <div className="w-full md:w-1/2 flex flex-col justify-center items-center px-6 py-10">
//           <form className="w-full max-w-md mx-auto" onSubmit={handleSubmit}>
//             <h2 className="text-3xl font-extrabold mb-3 text-center text-blue-700">
//               Login
//             </h2>
//             {error && (
//               <div className="mb-3 text-red-500 text-center">{error}</div>
//             )}
//             <div className="space-y-5">
//               <div>
//                 <label
//                   htmlFor="email"
//                   className="block mb-1 text-sm font-semibold text-gray-700"
//                 >
//                   Email
//                 </label>
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   placeholder="Email"
//                   className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
//                   value={form.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//               <div>
//                 <label
//                   htmlFor="password"
//                   className="block mb-1 text-sm font-semibold text-gray-700"
//                 >
//                   Password
//                 </label>
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   placeholder="Password"
//                   className="w-full px-4 py-3 rounded-xl border border-gray-300 bg-white/70 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
//                   value={form.password}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>
//             <button
//               type="submit"
//               disabled={loading}
//               className="w-full mt-8 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-fuchsia-600 text-white text-lg font-bold hover:scale-[1.01] shadow-md hover:shadow-xl transition"
//             >
//               {loading ? "Logging in..." : "Login"}
//             </button>
//             <div className="mt-6 text-center">
//               <span
//                 className="text-blue-600 hover:underline cursor-pointer font-semibold"
//                 onClick={() => navigate("/register")}
//               >
//                 New user? <span className="underline">Register</span>
//               </span>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged,
} from "firebase/auth";
import { auth, db } from "../firebase";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import AuthShell from "../components/AuthShell";
import { getAuthErrorMessage } from "../utils/authErrors";

const ROLE_ALLOWED_IN_THIS_APP = "referral"; // this is the referral portal

const Eye = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path
      d="M1.5 12s3.75-7.5 10.5-7.5S22.5 12 22.5 12 18.75 19.5 12 19.5 1.5 12 1.5 12Z"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <circle cx="12" cy="12" r="3.5" stroke="currentColor" strokeWidth="1.8" />
  </svg>
);

const EyeOff = (props) => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M3 3l18 18" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M1.5 12s3.75-7.5 10.5-7.5c2.1 0 3.98.62 5.6 1.62M22.5 12s-3.75 7.5-10.5 7.5c-2.1 0-3.98-.62-5.6-1.62"
      stroke="currentColor"
      strokeWidth="1.8"
    />
    <path
      d="M9.4 9.4a3.5 3.5 0 004.9 4.9"
      stroke="currentColor"
      strokeWidth="1.8"
    />
  </svg>
);

const fieldClassName =
  "w-full rounded-2xl border border-[#ead7b0] bg-white/90 px-4 py-3 text-[#4e3520] shadow-[0_12px_30px_-28px_rgba(69,39,15,0.45)] outline-none transition placeholder:text-[#b39368] focus:border-[#c99649] focus:ring-2 focus:ring-[#efd8aa]";

const primaryButtonClassName =
  "w-full rounded-2xl bg-[linear-gradient(135deg,#a56a22,#d6a654)] px-4 py-3 text-sm font-semibold text-white shadow-[0_20px_40px_-24px_rgba(118,73,20,0.65)] transition hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-60";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetOpen, setResetOpen] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [resetError, setResetError] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const cred = await signInWithEmailAndPassword(
        auth,
        form.email.trim(),
        form.password
      );
      const u = cred.user;

      // (Optional) block unverified emails
      // if (!u.emailVerified) {
      //   await signOut(auth);
      //   setLoading(false);
      //   setError("Please verify your email before logging in.");
      //   return;
      // }

      // Check referral profile first
      const refSnap = await getDoc(doc(db, "referral_users", u.uid));
      const userSnap = await getDoc(doc(db, "users", u.uid));

      let role = null;
      if (refSnap.exists()) role = "referral";
      else if (userSnap.exists() && userSnap.data()?.role === "instructor") {
        role = "instructor";
      }

      // Role-aware routing
      if (role === "referral") {
        setLoading(false);
        navigate("/dashboard"); // referral dashboard route
        return;
      }

      if (role === "instructor") {
        // User exists but in the wrong portal — prevent blank page
        await signOut(auth);
        setLoading(false);
        setError(
          "This is the Referral portal. Please log in through the Instructor portal."
        );
        return;
      }

      // No role doc found — likely first-time login to wrong portal
      await signOut(auth);
      setLoading(false);
      setError(
        "Account not found in Referral portal. If you’re an instructor, use the Instructor login."
      );
    } catch (err) {
      console.error("referral login failed", err?.code || err);
      setLoading(false);
      setError(getAuthErrorMessage(err, "login"));
    }
  };

  const openReset = () => {
    setResetError("");
    setResetMsg("");
    setResetEmail(form.email || "");
    setResetOpen(true);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setResetError("");
    setResetMsg("");
    const email = (resetEmail || "").trim();
    if (!email) {
      setResetError("Please enter your email.");
      return;
    }
    setResetLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setResetMsg(
        "If an account exists for this email, a password reset link has been sent."
      );
    } catch (err) {
      setResetError(getAuthErrorMessage(err, "resetPassword"));
    } finally {
      setResetLoading(false);
    }
  };

  useEffect(() => {
    if (!resetOpen) return;
    const onKey = (e) => e.key === "Escape" && setResetOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [resetOpen]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (currentUser) => {
      if (!currentUser) return;
      const refSnap = await getDoc(doc(db, "referral_users", currentUser.uid));
      if (refSnap.exists()) {
        navigate("/dashboard", { replace: true });
        return;
      }
      await signOut(auth).catch(() => {});
    });
    return () => unsub();
  }, [navigate]);

  return (
    <>
      <AuthShell
        portalLabel="Referral Portal"
        badge="Welcome Back"
        title="Sign in to the Referral Portal"
        description="Access your referral dashboard, network growth, and commissions with the same premium auth experience used across Ceylon Web Mall."
        footer={
          <>
            Need an invite link?{" "}
            <Link
              to="/register"
              className="font-semibold text-[#9b6b2f] transition hover:text-[#7e541f]"
            >
              Register here
            </Link>
          </>
        }
      >
        <div className="mx-auto w-full max-w-md">
          {error && (
            <div className="mb-4 rounded-2xl border border-[#e7b0ab] bg-[#fff4f3] px-4 py-3 text-sm text-[#9f3b2f]">
              {error}
            </div>
          )}
          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="email"
                className="mb-2 block text-sm font-semibold text-[#6c4d2c]"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
                className={fieldClassName}
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="mb-2 block text-sm font-semibold text-[#6c4d2c]"
              >
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="********"
                  className={`${fieldClassName} pr-12`}
                  value={form.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((s) => !s)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  aria-pressed={showPassword}
                  className="absolute inset-y-0 right-2 my-auto rounded-xl p-2 text-[#8c6b46] transition hover:bg-[#fff5e1] hover:text-[#5b3d1d]"
                >
                  {showPassword ? (
                    <EyeOff className="h-5 w-5" />
                  ) : (
                    <Eye className="h-5 w-5" />
                  )}
                </button>
              </div>
              <div className="mt-2 text-right">
                <button
                  type="button"
                  onClick={openReset}
                  className="text-sm font-medium text-[#9b6b2f] transition hover:text-[#7e541f]"
                >
                  Forgot password?
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className={primaryButtonClassName}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            <div className="rounded-2xl border border-[#f0dfc0] bg-[#fff9ef] px-4 py-3 text-center text-xs text-[#7d6241]">
              This portal accepts <b>{ROLE_ALLOWED_IN_THIS_APP}</b> accounts
              only.
            </div>
          </form>
        </div>
      </AuthShell>

      {resetOpen && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-[#2b1d0e]/55"
            onClick={() => setResetOpen(false)}
          />
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <div className="relative w-full max-w-md rounded-[28px] border border-[#ead7b0] bg-[linear-gradient(180deg,#fffdf8_0%,#fff5e6_100%)] p-6 shadow-[0_36px_80px_-40px_rgba(69,39,15,0.55)]">
              <button
                className="absolute right-4 top-3 text-2xl leading-none text-[#8c6b46] transition hover:text-[#5b3d1d]"
                aria-label="Close reset password dialog"
                onClick={() => setResetOpen(false)}
              >
                ×
              </button>

              <h3 className="mb-1 text-xl font-bold text-[#4e3520]">
                Reset password
              </h3>
              <p className="mb-4 text-sm text-[#7d6241]">
                Enter your email and we&apos;ll send you a link to reset your
                password.
              </p>

              {resetError && (
                <div className="mb-3 rounded-2xl border border-[#e7b0ab] bg-[#fff4f3] px-4 py-3 text-sm text-[#9f3b2f]">
                  {resetError}
                </div>
              )}
              {resetMsg && (
                <div className="mb-3 rounded-2xl border border-[#c8ddb3] bg-[#f4faee] px-4 py-3 text-sm text-[#527239]">
                  {resetMsg}
                </div>
              )}

              <form onSubmit={handleReset}>
                <label
                  htmlFor="reset-email"
                  className="mb-2 block text-sm font-semibold text-[#6c4d2c]"
                >
                  Email
                </label>
                <input
                  id="reset-email"
                  type="email"
                  className={`${fieldClassName} mb-4`}
                  placeholder="you@example.com"
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  autoComplete="email"
                  required
                />

                <div className="flex justify-end gap-2">
                  <button
                    type="button"
                    className="rounded-2xl border border-[#ead7b0] px-4 py-2 text-[#6c4d2c] transition hover:bg-[#fff8ec]"
                    onClick={() => setResetOpen(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    disabled={resetLoading}
                    className="rounded-2xl bg-[linear-gradient(135deg,#a56a22,#d6a654)] px-4 py-2 text-white transition hover:brightness-105 disabled:opacity-60"
                  >
                    {resetLoading ? "Sending..." : "Send reset link"}
                  </button>
                </div>
              </form>

              <p className="mt-3 text-xs text-gray-500">
                Tip: check your spam folder if you don&apos;t see the email.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
